import {domid} from "../../../_js/utils";

/*
 Usage:
 m(forecastLegend, {
 visible: true,           // forced initial state
 onhide: ()=>something(), // optional callback
 onshow: ()=>something(), // optional callback
 })
 */

export default function (widget) {
    const m = widget.m;
    const µ = widget.µ;
    const state = widget.state;
    const t = widget.txt;

    const ns = widget.ns + '__legend';

    const forecastLegend = {
        controller: function (props) {
            const ctrl = this;
            ctrl.isVisible = props && props.visible; // set once only
            ctrl.boxDomid = domid(ns);


            ctrl.hide = function () {
                ctrl.isVisible = false;
                const onhide = ctrl.props.onhide;
                onhide && onhide();
            };
            ctrl.show = function () {
                ctrl.isVisible = true;
                const onshow = ctrl.props.onshow;
                onshow && onshow();
            };
            ctrl.toggle = function () {
                ctrl.isVisible ? ctrl.hide() : ctrl.show();
                this.blur();
            };

            ctrl.closeOnEsc = function (elm, isRefresh, ctx) {
                if (!isRefresh) {
                    µ.onEvent(ctx, widget.env.document, 'keydown', function (e) {
                        if (e.which === 27) { // ESC
                            ctrl.hide();
                            m.redraw();
                        }
                    });
                }
            };

            const last = {};
            ctrl.maySkipRendering = function () {
                const maySkip = state.forecastData === last.forecastData &&
                    state.forecastType === last.forecastType &&
                    ctrl.isVisible === last.isVisible;
                last.forecastData = state.forecastData;
                last.forecastType = state.forecastType;
                last.isVisible = ctrl.isVisible;
                return maySkip;
            };
        },


        view: function (ctrl, props) {
            ctrl.props = props || {};

            if (ctrl.maySkipRendering()) {
                return {subtree: 'retain'};
            }

            const fd = state.forecastData;
            const scaleUrlTpl = fd && fd.scale_url;
            if (!scaleUrlTpl) {
                return m('div');
            }

            const tl0 = fd.timeline[0] || {};
            const scaleUrl = scaleUrlTpl
                .replace('[job_ref]', tl0.job_ref)
                .replace('[plot_spec]', state.forecastType.plot);

            const closeText = t('$legend__close');
            const togglerText = ctrl.isVisible ? closeText : t('$legend__open');
            return (
                m('div', {
                        className: ns + '-wrapper',
                        config: ctrl.closeOnEsc
                    },
                    m('button', {
                            className: ns + 'toggler',
                            onclick: ctrl.toggle,
                            title: togglerText,
                            'aria-controls': ctrl.boxDomid,
                        },
                        togglerText
                    ),
                    m('div', {
                            className: ns + 'box',
                            id: ctrl.boxDomid,
                            'aria-hidden': !ctrl.isVisible,
                        },
                        m('h3', {className: ns + 'box__title'},
                            //t(state.forecastType.plot_name)  // Plot name can be really long now and it's on the screen anyway
                            t('$legend__legendalt')
                        ),
                        m('img', {
                            className: ns + 'box__legend',
                            // alt: t('$legend__legendalt'),
                            alt: '',  // It now says "Map Legend" just above the image
                            src: scaleUrl,
                        }),
                        m('button', {
                                className: ns + 'box__closebutton',
                                onclick: ctrl.hide,
                                title: closeText,
                            },
                            closeText
                        )
                    )
                )
            );
        },
    };


    return forecastLegend;
}
